export default __webpack_public_path__ + "static/media/login.a83399c2.jpg";